export class HttpMediaService {
  constructor(baseUrl) {
    this.baseUrl = baseUrl;
  }

  async search(filters) {
    const queryParams = new URLSearchParams();

    if (filters.state) {
      queryParams.append('state', filters.state);
    }

    const res = await fetch(`${this.baseUrl}/api/v1/medias?${queryParams}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
    });

    if (!res.ok) {
      throw new Error('ERROR');
    }

    return res.json();
  }
}
